import UltMeta, { Meta } from "@/meta/UltMeta/index";

/**
 * 审核状态 待分派:1,待处理:2,已驳回:3,处理中:4,待审核:5,待确认:6,已确认:7,已搁浅:8,已完成:9,已关闭:10
 */
class IntendState extends UltMeta {
    STAY_ASSIGN = new Meta(1, "待指派");
    PENDING = new Meta(2, "待处理");
    REJECTED = new Meta(3, "已驳回");
    PROCESSING = new Meta(4, "处理中");
    WAIT_AUDIT = new Meta(5, "待审核");
    WAIT_CONFIRM = new Meta(6, "待确认");
    CONFIRMED = new Meta(7, "已确认");
    STRANDING = new Meta(8, "已搁浅", "color-info");
    COMPLETED = new Meta(9, "已完成", "color-info");
    CLOSED = new Meta(10, "已关闭", "color-info");
    /**后端不接0, 不传值 */
    UN_CLOSED = new Meta(0, "未关闭");
}

export const INTEND_STATE = new IntendState();

/**
 * 专员类型
 */
class OfficerType extends UltMeta {
    REPRESENTATIVE = new Meta(1, "服务专员");
    SUPERVISOR = new Meta(2, "服务主管");
}

export const OFFICER_TYPE = new OfficerType();

/**
 * 采购类型
 */
class PurchaseType extends UltMeta {
    DIRECT = new Meta(2, "直采");
    INDIRECT = new Meta(1, "联合采购");
}

export const PURCHASE_TYPE = new PurchaseType();

/**
 * 	审核类型 1 同意 2 拒绝:
 */
class AuditType extends UltMeta {
    AGREE = new Meta(1, "同意");
    REJECT = new Meta(2, "驳回");
}

export const AUDIT_TYPE = new AuditType();
